/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MessageType {
    TEXT = 'TEXT',
    PHOTO_REQUEST = 'PHOTO_REQUEST',
    PHOTO_SHARE = 'PHOTO_SHARE',
    INSTAGRAM = 'INSTAGRAM',
    TELEGRAM = 'TELEGRAM',
    WHATSAPP = 'WHATSAPP',
}
